import generateNestedFieldAccessor from './generateNestedFieldAccessor';

/**
 * Get fields of the first level
 * @param {Array} detailsKeys Keys list of fields to extract
 * @param {Object} fields Fields
 * @returns {Object} Object containing first level fields
 */
const setFirstLevelFields = (detailsKeys, fields) => {
    return Object.fromEntries(
        Object.entries(fields).filter(([key]) =>
            detailsKeys.includes(key)
        )
    );
};

/**
 * Get fields of second nested level
 * @param {Array} detailsKeys Keys list of fields to extract
 * @param {Object} fields Fields
 * @returns {Object} Final object containing extracted fields
 */
const flattenFieldsObjects = (detailsKeys, fields) => {
    const updatedFields = { ...setFirstLevelFields(detailsKeys, fields) };
    const reorderedFields = {};

    // Check if there at least one nested key in detailsKeys
    const haveNestedKeys = detailsKeys.some((key) => key.split('.').length > 1);

    if (haveNestedKeys) {
        detailsKeys.forEach((key) => {
            const keyParts = key.split('.');
            const nestedField = fields[keyParts[0]]?.[keyParts[1]];

            if (nestedField) {
                updatedFields[key] = {
                    ...nestedField,
                    key: generateNestedFieldAccessor(nestedField, fields[key])
                };
                // Remove perentKeys property
                delete updatedFields[key].parentKeys;
            }

            // Reorder object properties with same order in detailsKeys array
            if (updatedFields[key]) {
                reorderedFields[key] = updatedFields[key];
            }
        });

        if (Object.keys(reorderedFields).length) {
            return reorderedFields;
        }
    }

    return updatedFields;
};

export { flattenFieldsObjects };